import type { DataTableColumn } from '@/components/custom/erp';
import type { PhiNganHang } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<PhiNganHang>[] => [
  {
    field: 'ma_cpnh',
    headerName: 'Mã phí',
    width: 150
  },
  {
    field: 'ten_cpnh',
    headerName: 'Tên phí',
    width: 250
  },

  {
    field: 'tk_cpnh',
    headerName: 'Tài khoản phí',
    width: 120,
    renderCell: params => {
      return params.row.tk_cpnh_data?.code || '';
    }
  },
  {
    field: 'ma_thue',
    headerName: 'Thuế suất',
    width: 180,
    renderCell: params => {
      return params.row.ma_thue_data?.ten_thue || '';
    }
  }
];

interface AccountConstraintRow {
  ten_doi_tuong: string;
  bat_buoc_nhap: string | boolean;
}

export const accountContraint = (): DataTableColumn<AccountConstraintRow>[] => [
  {
    field: 'ten_doi_tuong',
    headerName: 'Tên đối tượng',
    width: 200
  },
  {
    field: 'bat_buoc_nhap',
    headerName: 'Bắt buộc nhập',
    width: 200
  }
];
